const mEditionBillingAcademyUsersProfile = {
  mEditionBillingAcademyUsersProfile: {
    alerts: {
      updateAcademiaActorEstado: {
        activationSuccess: 'El rol de usuario fue activado exitosamente.',
        deactivationSuccess: 'El rol de usuario fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    messages: {
      activeSince: 'Activo desde',
      lastAccess: 'último ingreso',
      lastLogin: 'Último login:',
      noContact: 'sin información de contacto',
      mobile: 'Móvil',
      noLegal: 'sin información legal',
      noLocation: 'sin información de ubicación',
      noNumber: 'sin número',
      noTracking: 'sin registros',
      phone: 'Teléfono',
      progress: 'progreso',
      progressActive: 'sobre lo activado:'
    },

    title: 'ROLES DE USUARIO',
    titleAssets: 'INSCRIPCIONES'
  }
}
export default mEditionBillingAcademyUsersProfile
